import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { PlaceBetRequest } from '@bpos/v2/bet-placement';
import { ApiService } from '@frontend/sports/common/api-utils';
import { BetslipNotificationRequest, BetslipNotificationResponse, PlaceBetResponse } from '@frontend/sports/types/betslip';
import { BetContextualDetails, SaveBetContextRequest } from '@frontend/sports/types/betslip/request';
import { Observable } from 'rxjs';

@Injectable()
export default class PlaceBetService {
    constructor(private apiService: ApiService) {}

    placeBet(
        placeBetRequest: PlaceBetRequest,
        betContextualDetails: BetContextualDetails[],
        betContextualDetailsV2?: SaveBetContextRequest,
    ): Observable<HttpResponse<PlaceBetResponse>> {
        return this.apiService.post<HttpResponse<PlaceBetResponse>>(
            'placebet/place',
            { placeBetRequest, betContextualDetails, betContextualDetailsV2 },
            {
                cache: false,
                retryCount: 0,
                showSpinner: false,
                resolveWithFullResponse: true,
            },
        );
    }

    queryStatus(requestId: string): Observable<HttpResponse<PlaceBetResponse>> {
        return this.apiService.get<HttpResponse<PlaceBetResponse>>('placebet/querystatus?requestId=' + requestId, void 0, {
            retryCount: 0,
            showSpinner: false,
            resolveWithFullResponse: true,
        });
    }

    setNotification(request: BetslipNotificationRequest): Observable<HttpResponse<BetslipNotificationResponse>> {
        return this.apiService.post<HttpResponse<BetslipNotificationResponse>>('placebet/setnotification', request, {
            cache: false,
            retryCount: 0,
            showSpinner: false,
            resolveWithFullResponse: true,
        });
    }
}
